module.exports = require('./dist/lib/app')
